module.exports = __webpack_public_path__ + "img/aether-seep-cover.bd9f4054.jpg";